export default class SimulatorData {

    constructor(public Id = "", public attackAngle: number | undefined = undefined, public dynamicLoft: number | undefined = undefined, public ballSpeed = 0, 
                public clubSpeed = 0, public headSpeed = 0, public launchAngle = 0, public backSpin = 0, public carryDistance = 0) {}
}